import React from "react";
import { RootStackParamList } from "../types/navigationParams";
import DynamicForm from "../components/DynamicForm";
import { DrawerScreenProps } from "@react-navigation/drawer";
import { useTheme } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { Dimensions, Pressable, StyleSheet, View } from "react-native";
import { useScreenSize } from "../hooks/useScreenSize";

const { height, width } = Dimensions.get("window");

type Props = DrawerScreenProps<RootStackParamList, "PaymentsFormScreen">;

export default function PaymentsFormScreen({ route, navigation }: Props) {
  const { existingItem, collection, onNewDocumentCallback } = route.params;
  const { t } = useTranslation();
  const theme = useTheme();

  const { LARGE_SCREEN } = useScreenSize();

  const handleSubmit = async (data: any) => {
    onNewDocumentCallback({ ...data, createdAt: new Date() });
    navigation.goBack();
  };

  return (
    <>
      <View style={styles.overlay}>
        {LARGE_SCREEN && (
          <Pressable style={{ flex: 1 }} onPress={() => navigation.goBack()} />
        )}
        <View
          style={[
            styles.container,
            {
              backgroundColor: theme.colors.background,
            },
          ]}
        >
          <DynamicForm
            existingData={existingItem}
            fields={collection.fields}
            handleSubmit={handleSubmit}
            collectionName={collection.name}
            collection={collection}
          />
        </View>
        {LARGE_SCREEN && (
          <Pressable style={{ flex: 1 }} onPress={() => navigation.goBack()} />
        )}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    justifyContent: "center",
    paddingHorizontal: width > 1000 ? 20 : 0,
  },
  container: {
    padding: 16,
    alignSelf: "center",
    width: "100%",
    maxWidth: 800,
    maxHeight: width > 1000 ? 700 : height,
    flexGrow: width > 1000 ? 0 : 1,
    backgroundColor: "red",
  },
  headerButtons: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  },
});
